import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'
import ActivityWrapupCardWithAction from 'src/pages/ActivityWrapup/subcomponents/ActivityWrapupCardWithAction/ActivityWrapupCardWithAction'
import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'

const WrapupCardPracticeWriting = ({
  mediaThumbnailUrl,
  practiceWritingHref,
}) => {
  return (
    <ActivityWrapupCardWithAction
      title={t('Practice Writing')}
      description={t(
        'Practice writing a short entry using the words you have been studying.'
      )}
      action={{
        label: t('Start writing'),
        href: practiceWritingHref,
      }}
      imageSection={
        mediaThumbnailUrl && (
          <AspectRatioImage
            imgUrl={mediaThumbnailUrl}
            aspectRatio="16:9"
            borderRadius="0,5x"
          />
        )
      }
    />
  )
}

WrapupCardPracticeWriting.propTypes = {
  mediaThumbnailUrl: PropTypes.string,
  practiceWritingHref: PropTypes.string.isRequired,
}

export default WrapupCardPracticeWriting
